/**
 * nb-c-product-sticky.js
 * Page-specific behaviour for snippets/nb-c-product-sticky.liquid: reads
 * nb:option-change events from the page's [data-nb-option-group] to keep the
 * closed bar's label/price/button in sync, and re-homes that same option-group
 * node into the sheet (never a copy) so there is one source of truth for the
 * selection. Sheet open/close mechanics themselves are nb-ui.js's generic
 * sheet module (data-nb-sheet / data-nb-sheet-open / data-nb-sheet-close),
 * used verbatim; this file only moves the DOM node and syncs text/attrs.
 */
(function () {
  'use strict';

  function init(root) {
    if (root.hasAttribute('data-nb-product-sticky-init')) return;
    root.setAttribute('data-nb-product-sticky-init', '');

    var groupId = root.getAttribute('data-nb-product-sticky-group');
    var sheetId = root.getAttribute('data-nb-product-sticky-sheet');
    var nameEl = root.querySelector('[data-nb-sticky-selected]');
    var actionBtn = root.querySelector('[data-nb-sticky-action]');
    var sheet = sheetId ? document.getElementById(sheetId) : null;
    var slot = sheet ? sheet.querySelector('[data-nb-product-sticky-slot]') : null;
    var sheetAction = sheet ? sheet.querySelector('[data-nb-sticky-sheet-action]') : null;
    var sheetTotal = sheet ? sheet.querySelector('[data-nb-sticky-sheet-total]') : null;
    var group = groupId ? document.getElementById(groupId) : null;
    var groupHome = group ? group.parentNode : null;
    var groupNextSibling = group ? group.nextSibling : null;
    var moved = false;

    function setSelection(detail) {
      if (!detail) return;
      /* CRO A3 fix, 2026-09-29: was `detail.price` (raw variant cents, e.g.
         57500), never formatted, and only ever ran after a change event so
         the SSR default ("Default Title · $575") never updated on load.
         priceText is the money string nb-ui.js's option-group module already
         carries through from the card's own server-rendered
         data-nb-option-price-text (money_without_trailing_zeros, site
         convention, no currency code); falls back to price for callers that
         don't pass it. */
      var priceDisplay = detail.priceText !== undefined ? detail.priceText : detail.price;
      if (nameEl && detail.label !== undefined && priceDisplay !== undefined) {
        nameEl.textContent = detail.label + ' · ' + priceDisplay;
      } else if (nameEl && priceDisplay !== undefined) {
        nameEl.textContent = priceDisplay;
      }
      if (actionBtn && detail.variantId) {
        actionBtn.setAttribute('data-nb-variant-id', detail.variantId);
        actionBtn.removeAttribute('data-nb-sheet-open');
        actionBtn.disabled = false;
      }
      if (sheetAction && detail.variantId) {
        sheetAction.setAttribute('data-nb-variant-id', detail.variantId);
        sheetAction.disabled = false;
      }
      if (sheetTotal && priceDisplay !== undefined) sheetTotal.textContent = priceDisplay;
    }

    function fromEventDetail(d) {
      return {
        label: d.label || d.key,
        price: d.price,
        priceText: d.priceText,
        variantId: d.variantId
      };
    }

    if (group) {
      group.addEventListener('nb:option-change', function (e) {
        setSelection(fromEventDetail(e.detail || {}));
      });

      /* Sync to whichever card is already checked at load, so the closed
         bar reads the real default selection instead of the product's own
         "Default Title" fallback until the shopper first taps something. */
      var checkedInput = group.querySelector('input[type="radio"]:checked');
      var checkedCard = checkedInput && checkedInput.closest('.nb-c-option-card');
      if (checkedCard) {
        setSelection(fromEventDetail({
          key: checkedCard.getAttribute('data-nb-option-key'),
          label: checkedCard.getAttribute('data-nb-option-label'),
          price: checkedCard.getAttribute('data-nb-option-price'),
          priceText: checkedCard.getAttribute('data-nb-option-price-text'),
          variantId: checkedCard.getAttribute('data-nb-option-variant-id')
        }));
      }
    }

    // Move the real option group into the sheet on first open, move it back
    // on close. This keeps exactly one live set of option-card inputs on the
    // page at all times, so a selection made in the sheet is the same
    // selection the buy column (and this bar) already reads.
    if (sheet && slot && group) {
      sheet.addEventListener('nb:open', function () {
        if (moved) return;
        slot.appendChild(group);
        moved = true;
      });
      sheet.addEventListener('nb:close', function () {
        if (!moved) return;
        if (groupNextSibling && groupNextSibling.parentNode === groupHome) {
          groupHome.insertBefore(group, groupNextSibling);
        } else if (groupHome) {
          groupHome.appendChild(group);
        }
        moved = false;
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-nb-product-sticky]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();
